export default "__VITE_PUBLIC_ASSET__3a3c4f0d__"